export const translations = {
  fr: {
    // Landing / General
    loading: "Chargement...",
    contactUs: "Contacter nous",

    // Accessibility
    contactWhatsApp: "Contactez-nous sur WhatsApp",
    videoFallback: "Votre navigateur ne supporte pas la balise vidéo.",
    search: "Recherche",
    cart: "Panier",
    menu: "Menu",
    labelFrench: "Français",
    labelEnglish: "Anglais",
    altWhatsApp: "WhatsApp",
    altMessenger: "Messenger",
    altInstagram: "Instagram",
    altLocation: "Localisation",
    altPhone: "Téléphone",
    altEmail: "E-mail",
    altMap: "Carte",

    cookieSettings: "Paramètres des Cookies",
    cookieMessage: "Notre site utilise des cookies pour améliorer votre expérience et mémoriser vos préférences (langue, données de navigation, etc.). En acceptant, vous consentez à l'utilisation de ces cookies.",
    accept: "Accepter",
    decline: "Refuser",
    browserSettings: "Vous pouvez modifier vos préférences dans les paramètres du navigateur.",

    // Accessories Page
    accHeroTitle: "Accessoires Premium",
    accHeroDesc: "Complétez votre expérience numérique avec nos accessoires soigneusement sélectionnés pour leur qualité, design et performance.",
    showPrices: "Afficher les prix",
    hidePrices: "Cacher les prix",
    pricesVisible: "Prix visibles",
    pricesHidden: "Prix masqués",
    foundAccessories: "accessoires trouvés",
    inCategory: "dans",
    reviews: "avis",
    featuresCount: "fonctionnalités",
    add: "Ajouter",
    discover: "Découvrir",
    viewMoreAccessories: "Voir plus d'accessoires",

    // Categories
    catAllAccessories: "Tous les accessoires",
    catAudio: "Audio",
    catProtection: "Protection",
    catCharging: "Chargement",
    catSmartwatch: "Montres connectées",
    catPhotoVideo: "Photo & Vidéo",
    catSmartHome: "Maison connectée",

    // Colors
    colorWhite: "Blanc",
    colorBlack: "Noir",
    colorBlue: "Bleu",
    colorSilicone: "Silicone",
    colorTransparent: "Transparent",
    colorGrey: "Gris",
    colorBlackWhite: "Noir/Blanc",
    colorSilver: "Argent",
    colorCharcoal: "Gris Charbon",
    colorMidnight: "Minuit",

    // Badges
    badgeWaterproof: "Waterproof",
    badgeTopQuality: "Top Qualité",
    badgeMagSafe: "MagSafe",
    badgeScratchResist: "Anti-rayure",
    badgeKeyboard: "Clavier Intégré",
    badgeFast: "Rapide",
    badgeUltraFast: "Ultra Rapide",
    badge3in1: "3-en-1",
    badgeHighCap: "Haute Capacité",
    badgeAutonomy: "Autonomie",
    badgeProGaming: "Pro Gaming",
    badgeWireless: "Wireless",
    badgeRGB: "RGB",
    badgeProPhoto: "Pro Photo",
    badgeStabilization: "Stabilisation",
    badgeVoiceAssist: "Assistant Vocal",
    badgeSmartLight: "Éclairage Smart",

    // Features
    featANCActive: "Annulation active bruit",
    featANCPro: "ANC Pro",
    featSound30W: "Son puissant 30W",
    featIP67: "Résistance IP67",
    featPartyBoost: "PartyBoost",
    featHiRes: "Hi-Res Audio",
    featVoiceAssist: "Assistant vocal",
    featAppleAndroid: "Apple/Android",
    featShockProtect: "Protection chocs",
    featSiliconeFinish: "Finition silicone",
    featAntiTrace: "Anti-trace",
    featHard9H: "Dureté 9H",
    featAntiReflect: "Anti-reflet",
    featEasyInstall: "Facile installation",
    featPack2: "Pack de 2",
    featBacklitKey: "Clavier rétro-éclairé",
    featTrackpad: "Trackpad",
    featProtect360: "Protection 360°",
    featFoldable: "Pliable",
    featFastCharge15W: "Charge rapide 15W",
    feat2Devices: "2 appareils",
    featLEDInd: "LED indicateur",
    featCompact: "Compact",
    featFastCharge240W: "Charge rapide 240W",
    featData40Gbps: "Données 40Gbps",
    featNylon: "Nylon tressé",
    feat2m: "2m longueur",
    feat3in1Charge: "Charge iPhone/AirPods/Apple Watch",
    featMFi: "Certifié MFi",
    featPD30W: "PD 30W",
    feat3Ports: "3 ports",
    featLCD: "LCD écran",
    featScreen15Watch: 'Écran 1.5"',
    featBatt40h: "Batterie 40h",
    featECG: "ECG",
    featRotatingBezel: "Tournante bezel",
    featAlwaysOn: "Écran Always-On",
    featGPS: "GPS",
    featBatt14d: "14 jours batterie",
    featSportModes: "100+ modes sport",
    featSpO2: "SpO2",
    featPremDesign: "Design premium",
    featCustomControls: "Contrôles personnalisables",
    featHaptic: "Retour haptique",
    featProfiles: "Profiles",
    featSpatial360: "Son spatial 360°",
    featBatt38h: "Batterie 38h",
    featRetractMic: "Micro rétractable",
    featMultiPlat: "Multi-plateforme",
    featMechSwitch: "Switches mécaniques",
    featRGB: "RGB personnalisable",
    featAntiGhost: "Anti-ghosting",
    featWristRest: "Wrist rest",
    featAudio24bit: "Audio 24-bit",
    featRange200m: "Portée 200m",
    featSafetyRec: "Enregistrement sécurité",
    featCompleteKit: "Kit complet",
    featWide18mm: "Grand angle 18mm",
    featPremLens: "Lentilles premium",
    featEasyMount: "Montage facile",
    featBagIncl: "Sac inclus",
    featStab3Axis: "Stabilisation 3 axes",
    featAutoExt: "Extension automatique",
    featTrackMode: "Mode suivi",
    featCompactFold: "Pliage compact",
    featGoogleAssist: "Assistant Google",
    featBetterSound: "Son amélioré",
    featHomeControl: "Contrôle domotique",
    featTextileDesign: "Design textile",
    feat3Bulbs: "3 ampoules LED",
    featBridgeIncl: "Bridge inclus",
    feat16MColor: "16M couleurs",
    featVoiceControl: "Contrôle vocal",

    // WhatsApp Message
    waMessage: "Bonjour l'équipe Michel Cell 👋 \n\nJe viens de consulter votre site web et je souhaite en savoir plus sur vos services. Pourriez-vous me fournir plus d'informations ?\n\n*Service qui m'intéresse :* [préciser ici]\n*Besoin spécifique :* [décrire ici]",

    // Hero1
    heroTitle: "Votre référence en matière du numérique",
    heroSubtitle: "Venez découvrir notre sélection premium de smartphones, accessoires et services techniques avec un accompagnement expert et personnalisé.",
    discoverCollection: "Découvrir la collection",
    buyingGuide: "Guide d'achat",

    // Navigation (Header) - assuming these will be needed
    home: "Accueil",
    products: "Produits",
    smartphones: "Smartphones",
    accessories: "Accessoires",
    about: "À propos",
    contact: "Contact",

    // Preview
    prevSlide: "Slide précédent",
    nextSlide: "Slide suivant",
    goToSlide: "Aller au slide",

    // Footer
    subscribe: "S'abonner",
    emailPlaceholder: "Votre email...",
    newsletterTitle: "Restez connecté",
    newsletterDesc: "Recevez nos dernières offres et actualités directement dans votre boîte mail.",
    newsletterSuccess: "Vous êtes maintenant inscrit à notre newsletter.",
    congrats: "Félicitations !",
    brandDesc: "Votre partenaire de confiance dans l'univers du numérique en Haïti. Nous vous accompagnons avec expertise et passion vers les technologies de demain.",

    // Footer Links
    ftProducts: "Produits",
    ftServices: "Services",
    ftCompany: "Entreprise",

    ftSmartphones: "Smartphones",
    ftAccessories: "Accessoires",
    ftGaming: "Gaming",
    ftLaptops: "Laptops & Tablettes",
    ftSmartwatches: "Montres Connectées",

    ftRepairs: "Réparations",
    ftGuide: "Guide d'achat",
    ftSupport: "Support technique",
    ftRefurb: "Reconditionnement",
    ftInstall: "Installation",

    ftStory: "Notre histoire",
    ftCareers: "Carrières",
    ftPress: "Presse",
    ftBlog: "Blog",
    ftEvents: "Événements",

    ftSupportTitle: "Support",
    ftHelpCenter: "Centre d'aide",
    ftContactUs: "Nous contacter",
    ftFAQ: "FAQ",
    ftServiceStatus: "État des services",

    ftLegalTitle: "Légal",
    ftLegalNotice: "Mentions légales",
    ftPrivacyPolicy: "Politique de confidentialité",
    ftTermsService: "Conditions d'utilisation",

    ftCookies: "Cookies",
    ftFollowUs: "Suivez-nous",
    ftCopyright: "Tous droits réservés.",
    ftSecurePayments: "Paiements sécurisés :",
    ftCustomerService: "Service client :",
    ftSecurePaymentBadge: "Paiement 100% sécurisé",
    ftFastDelivery: "Livraison rapide en Haïti",
    ftReturns: "Retours sous 15 jours",
    ftServiceScore: "Service client 5/5",

    // Address Components
    addrSud: "Département du Sud",
    addrNord: "Département du Nord",
    addrOuest: "Département de l'Ouest",
    addrCentre: "Département de l'Ouest",
    viewOnMap: "Voir sur la carte",

    // Image Gallery
    imgStorefront: "Notre boutique principale",
    imgInterior: "Espace d'exposition moderne",
    imgSmartphone: "Nos derniers smartphones",
    imgService: "Accompagnement personnalisé",
    imgRepair: "Atelier technique expert",
    imgGaming: "Zone dédiée aux gamers",
    imgAccessories: "Large choix d'accessoires",
    imgTeam: "Notre équipe d'experts",
    imgPrev: "Image précédente",
    imgNext: "Image suivante",
    goToImage: "Aller à l'image",

    // About Page
    aboutHeroTitle: "Notre Histoire",
    aboutHeroDesc: "De passionnés de technologie à référence numérique en Haïti, découvrez notre parcours, nos valeurs et notre mission.",
    aboutWhoTitle: "Qui sommes-nous ?",
    aboutWhoDesc: "Michel Cell est une entreprise haïtienne spécialisée dans la technologie mobile, l'électronique et les services de réparation. Nous nous sommes donné pour mission de rendre la technologie accessible à tous en Haïti.",
    aboutPresenceTitle: "Notre Présence",
    aboutPresenceDesc: "Présents dans 4 villes à travers Haïti avec 4 magasins physiques, nous sommes implantés au plus près de nos clients. Notre réseau s'agrandit constamment pour mieux servir chaque région.",
    aboutMissionTitle: "Notre Mission",
    aboutMissionDesc: "Démocratiser l'accès à la technologie de qualité en Haïti en offrant des produits adaptés, des services de réparation fiables et des conseils experts à des prix accessibles.",
    aboutCommitTitle: "Notre Engagement",
    aboutCommitDesc: "Chez Michel Cell, chaque client compte. Nous croyons en une approche personnalisée où l'écoute, le respect et la transparence sont au cœur de toutes nos interactions. Notre équipe s'engage à vous offrir le meilleur service, qu'il s'agisse d'un achat, d'une réparation ou d'un simple conseil.",

    valTitle: "Nos Valeurs",
    servicesTitle: "Nos Services",
    timelineTitle: "Notre Parcours",

    aboutValExpertise: "Expertise Technique",
    aboutValExpertiseDesc: "Nos techniciens sont certifiés et suivent des formations régulières pour maîtriser les dernières technologies.",
    aboutValTrust: "Confiance & Transparence",
    aboutValTrustDesc: "Nous établissons une relation de confiance avec nos clients grâce à une communication claire et transparente.",
    aboutValInnovation: "Innovation Continue",
    aboutValInnovationDesc: "Nous restons à la pointe de l'innovation pour vous proposer les produits et services les plus avancés.",
    aboutValPersonalized: "Service Personnalisé",
    aboutValPersonalizedDesc: "Chaque client est unique. Nous adaptons nos conseils et solutions à vos besoins spécifiques.",

    aboutStatsExp: "Ans d'expérience",
    aboutStatsCust: "Clients satisfaits",
    aboutStatsProd: "Produits en stock",
    aboutStatsRepair: "Appareils réparés",

    mile2017: "Ouverture",
    mile2017Desc: "Première boutique dans le sud d'Haïti",
    mile2019: "Expansion",
    mile2019Desc: "Ouverture de la deuxième boutique dans le nord",
    mile2020: "Service Réparation",
    mile2020Desc: "Lancement du service de réparation expert",
    mile2022: "E-commerce",
    mile2022Desc: "Mise en place de notre boutique en ligne",
    mile2023: "Gaming Zone",
    mile2023Desc: "Création d'un espace dédié aux gamers",
    mile2024: "Innovation",
    mile2024Desc: "Intégration de services de réalité augmentée",

    svcSalesTitle: "Vente de Produits",
    svcSalesDesc: "Smartphones, tablettes, accessoires et équipements électroniques des meilleures marques à des prix compétitifs.",
    svcRepairTitle: "Service de Réparation",
    svcRepairDesc: "Réparation rapide et fiable de tous types d'appareils électroniques par nos techniciens certifiés.",
    svcGamingTitle: "Espace Gaming",
    svcGamingDesc: "Produits et conseils spécialisés pour les gamers : consoles, accessoires, équipements streaming et plus encore.",

    // Brands Section
    brandsTitle: "Toutes les marques, un seul expert",
    brandsDesc: "Découvrez notre vaste sélection de marques de confiance, soigneusement choisies pour vous offrir le meilleur en matière de technologie et de performance.",

    // Brand Stats
    brandStatsBrands: "Marques disponibles",
    brandStatsExpert: "Expert",
    brandStatsSupport: "Accompagnement personnalisé",

    // Our Vision Section
    visionTitle: "Notre Vision et Nos Valeurs",
    visionDesc: "Révolutionner l'expérience numérique grâce à l'expertise, l'innovation et un engagement sans faille envers l'excellence.",
    missionTitle: "Notre Mission",
    missionDesc: "Chez MichelCell, notre mission est de fournir des solutions numériques innovantes et personnalisées qui répondent aux besoins uniques de chaque client. Nous nous efforçons de créer une expérience utilisateur exceptionnelle en combinant expertise technique, service client attentif et engagement envers la qualité.",
    commitmentTitle: "Notre Engagement",
    commitmentDesc: "Nous nous engageons à fournir des produits de qualité, des conseils d'experts et un service après-vente exceptionnel. Votre satisfaction est notre priorité absolue et nous travaillons chaque jour pour mériter votre confiance.",

    valInnovation: "Innovation Continue",
    valInnovationDesc: "Nous restons à la pointe de la technologie pour vous offrir les dernières innovations et tendances du marché numérique.",
    valQuality: "Qualité Premium",
    valQualityDesc: "Chaque produit est soigneusement sélectionné et testé pour garantir une excellence irréprochable.",
    valSupport: "Accompagnement Personnalisé",
    valSupportDesc: "Notre équipe d'experts vous guide dans vos choix avec des conseils adaptés à vos besoins spécifiques.",
    valSustainable: "Développement Durable",
    valSustainableDesc: "Nous nous engageons dans une démarche éco-responsable avec des produits reconditionnés et recyclables.",

    statsClients: "Clients Satisfaits",
    statsClientsDesc: "Une communauté fidèle qui nous fait confiance",
    statsProducts: "Produits Disponibles",
    statsProductsDesc: "Une sélection premium constamment mise à jour",
    statsExpertise: "Ans d'Expertise",
    statsExpertiseDesc: "Un savoir-faire acquis au fil des années",

    journeyTitle: "Notre Parcours",
    milestone2015Title: "Fondation",
    milestone2015Desc: "Ouverture de notre premier espace dédié au numérique",
    milestone2018Title: "Expansion",
    milestone2018Desc: "Lancement de notre service de réparation expert",
    milestone2021Title: "Transformation",
    milestone2021Desc: "Digitalisation complète et e-commerce",
    milestone2024Title: "Innovation",
    milestone2024Desc: "Intégration IA et réalité augmentée",

    ctaVisionTitle: "Prêt à Rejoindre l'Aventure ?",
    ctaVisionDesc: "Découvrez comment nous pouvons transformer votre expérience numérique et vous accompagner vers le futur technologique.",
    ctaDiscover: "Découvrir Nos Services",
    ctaAppointment: "Prendre Rendez-vous",

    // Products Preview
    featuredProductsTitle: "Nos Produits Phares",
    featuredProductsDesc: "Découvrez notre sélection exclusive de produits high-tech aux meilleurs prix.",
    addToCart: "Ajouter au panier",
    viewDetails: "Voir détails",
    addToFavorites: "Ajouter aux favoris",
    compare: "Comparer",
    viewAllProducts: "Voir tous les produits",

    // Products Page
    productsHeroTitle: "Notre Collection",
    productsHeroDesc: "Découvrez notre sélection premium de produits high-tech, soigneusement sélectionnés pour leur qualité et performance exceptionnelle.",

    sortLabel: "Trier par :",
    sortName: "Nom",
    sortPriceAsc: "Prix croissant",
    sortPriceDesc: "Prix décroissant",
    sortRating: "Meilleures notes",

    catAll: "Tous les produits",
    catTablets: "Tablettes",
    catSmartphones: "Smartphones",
    catLaptops: "Laptops",
    catGaming: "Gaming",

    stockLabel: "en stock",
    featuresLabel: "fonctionnalités",
    viewButton: "Voir",
    loadMore: "Charger plus de produits",

    statAvailable: "Produits disponibles",
    statRating: "Note moyenne",
    statDelivery: "Livraison express",

    // Additional Badges
    badgePro: "Professionnel",
    badgeUltimate: "Ultimate",
    badgeVersatile: "Polyvalent",

    // Additional Features
    featScreen67: 'Écran 6.7"',
    featScreen68: 'Écran 6.8"',
    featScreen14: '14" Liquid Retina',
    featScreen11: '11" Liquid Retina',
    featSPen: "S Pen",
    featCam200: "Camera 200MP",
    featChipM3Pro: "Chip M3 Pro",
    feat18GB: "18GB RAM",
    featChipM2: "Chip M2",
    featPencil: "Apple Pencil",
    feat5G: "5G",
    featGamePass: "Game Pass",
    featQuickResume: "Quick Resume",

    // Product Categories
    catSmartphone: "Smartphone",
    catConsole: "Console Gaming",
    catLaptop: "Laptop",
    catAccessories: "Accessoires",

    // Product Badges
    badgeNew: "Nouveau",
    badgeAI: "IA Intégrée",
    badgePromo: "Promo",
    badgeEco: "Écologie",
    badgeBestseller: "Best-seller",
    badgePure: "Android Pur",

    // Product Features (Mapping keys to strings)
    featScreen61: 'Écran 6.1" Super Retina XDR',
    featChipA17: "Chip A17 Pro",
    featCam48: "Camera 48MP",
    featTitanium: "Titanium",
    featScreen62: 'Écran 6.2" Dynamic AMOLED',
    featSnap8: "Snapdragon 8 Gen 3",
    featAI: "AI Integration",
    feat7Updates: "7 ans updates",
    feat1TB: "1TB SSD",
    feat4K: "4K 120Hz",
    featRayTracing: "Ray Tracing",
    featDualSense: "DualSense",
    featChipM3: "Chip M3",
    featScreen15: '15" Liquid Retina',
    feat18h: "18h autonomie",
    feat8GB: "8GB RAM",
    featANC: "Annulation active bruit",
    featSpatial: "Audio Spatial",
    featMagSafe: "MagSafe",
    feat30h: "30h batterie",
    featAndroid14: "Android 14",
    featCam50: "Camera 50MP",
    featTensor: "Tensor G3",

    // Testimonials
    testimonialsTitle: "Ce que disent nos clients",
    testimonialsSubtitle: "Découvrez les expériences de ceux qui nous font confiance pour leurs besoins technologiques.",
    prevTestimonial: "Témoignage précédent",
    nextTestimonial: "Témoignage suivant",
    goToTestimonial: "Aller au témoignage",

    testim1Role: "Kliyan satisfe",
    testim1Text: "Avek MichelCell, mwen jwenn yon telefòn ki nan gou mwen ! Sèvis kliyan an te ekselan e mwen rekòmande yo bay tout moun.",

    testim2Role: "Gamer passionné",
    testim2Text: "lontan mwen t ap chèche yon laptop pou jwèt videyo, MichelCell te ede m jwenn youn ki pafè pou bezwen mwen yo. Eksperyans achte a te fasil epi rapid.",

    testim3Role: "Professionnelle",
    testim3Text: "Mon MacBook est comme neuf après la réparation. Rapidité et expertise au rendez-vous. Un service de qualité que je vais recommander.",

    testim4Role: "Etidyan fakilte dwa",
    testim4Text: "Nan zafè acha telefòn ak akseswa, MichelCell te ban mwen yon eksperyans san parèy. Mèci pou tout èd la!",

    testim5Role: "Fotograf amate",
    testim5Text: "Mwen renmen nouvo kamera mwen an! MichelCell te ede m chwazi li epi sèvis la te ekstraòdinè. M'ap toujou achte isit la.",

    // Stats
    statClients: "Clients satisfaits",
    statProducts: "Produits vendus",
    statReviews: "Avis positifs",
    statSatisfaction: "Taux de satisfaction",
    statSupport: "Support réactif",

    // Contact Page
    contactHeroTitle: "Contactez-nous",
    contactHeroDesc: "Notre équipe est là pour répondre à toutes vos questions. N'hésitez pas à nous contacter pour des conseils, réparations ou toute autre demande.",
    contactQuickTitle: "Contact Rapide",
    contactEmergencyTitle: "🔴 Urgence Technique ?",
    contactEmergencyDesc: "Pour les réparations urgentes ou problèmes techniques critiques",
    contactEmergencyBtn: "Urgence : +509 4776 3992",
    contactRepairBtn: "Service Réparation",

    contactFormTitle: "Envoyez-nous un message",
    contactSuccessTitle: "✅ Message envoyé !",
    contactSuccessDesc: "Merci pour votre message. Notre équipe vous répondra dans les plus brefs délais.",
    contactLabelName: "Nom complet *",
    contactPlaceName: "Votre nom",
    contactLabelEmail: "Email *",
    contactPlaceEmail: "votre@email.com",
    contactLabelPhone: "Téléphone",
    contactPlacePhone: "+509 XX XX XX XX",
    contactLabelSubject: "Sujet *",
    contactSelectSubject: "Sélectionnez un sujet",
    contactLabelMessage: "Message *",
    contactPlaceMessage: "Décrivez votre demande en détail...",
    contactBtnSend: "Envoyer le message",
    contactBtnSending: "Envoi en cours...",
    contactDisclaimer: "* Champs obligatoires. Nous répondons généralement dans les 24h.",
    contactNewsletter: "Je souhaite recevoir les offres spéciales et actualités",

    contactSubjInfo: "Demande d'information",
    contactSubjSupport: "Support technique",
    contactSubjRepair: "Réparation d'appareil",
    contactSubjOrder: "Commande spéciale",
    contactSubjReturn: "Retour produit",
    contactSubjPartner: "Partenaire commercial",
    contactSubjOther: "Autre",

    contactFaqTitle: "Questions Fréquentes",
    contactFaq1Q: "Quels sont vos horaires d'ouverture ?",
    contactFaq1A: "Nos boutiques sont ouvertes du lundi au samedi de 8h à 19h, et le dimanche de 10h à 17h.",
    contactFaq2Q: "Combien de temps prend une réparation ?",
    contactFaq2A: "La plupart des réparations sont effectuées en 24-48h. Pour les cas complexes, nous vous tiendrons informés du délai estimé.",
    contactFaq3Q: "Offrez-vous la garantie sur vos produits ?",
    contactFaq3A: "Oui, tous nos produits bénéficient d'une garantie d'un an minimum. Les produits reconditionnés ont 6 mois de garantie.",
    contactFaq4Q: "Acceptez-vous les commandes en ligne ?",
    contactFaq4A: "Oui, vous pouvez commander en ligne et retirer en boutique, ou bénéficier de notre service de livraison.",
    contactFaqLink: "Voir toutes les FAQ",
    contactWhatsAppLabel: "WhatsApp: +(509) 4776 3992",
    contactFacebookLabel: "Facebook: @michelcell_ht",
    contactInstagramLabel: "Instagram: @michelcell_ht",
  },
  en: {
    // Dans votre fichier de traductions
    // catSmartwatches: "Smartwatches",
    // badgeValue: "Best Value",
    // badgeUnique: "Unique",
    // badgeClassic: "Classic",
    // badgeBusiness: "Business",
    // badgePowerful: "Powerful",
    // badgeGaming: "Gaming",
    // statBrands: "Marques disponibles",

    // HeaderLanding / General
    loading: "Loading...",
    contactUs: "Contact us",

    // Accessibility
    contactWhatsApp: "Contact us on WhatsApp",
    videoFallback: "Your browser does not support the video tag.",
    search: "Search",
    cart: "Cart",
    menu: "Menu",
    labelFrench: "French",
    labelEnglish: "English",
    altWhatsApp: "WhatsApp",
    altMessenger: "Messenger",
    altInstagram: "Instagram",
    altLocation: "Location",
    altPhone: "Phone",
    altEmail: "Email",
    altMap: "Map",

    cookieSettings: "Cookie Settings",
    cookieMessage: "Our site uses cookies to enhance your experience and remember your preferences (language, browsing data, etc.). By accepting, you consent to the use of these cookies.",
    accept: "Accept",
    decline: "Decline",
    browserSettings: "You can change your preferences in browser settings.",

    // WhatsApp Message
    waMessage: "Hello Michel Cell team 👋 \n\nI just visited your website and I would like to learn more about your services. Could you provide me with more information?\n\n*Service I'm interested in:* [specify here]\n*Specific need:* [describe here]",

    // Hero1
    heroTitle: "Your Reference in Digital Technology",
    heroSubtitle: "Come discover our premium selection of smartphones, accessories, and technical services with expert and personalized support.",
    discoverCollection: "Discover Collection",
    buyingGuide: "Buying Guide",

    // Navigation (Header)
    home: "Home",
    products: "Products",
    smartphones: "Smartphones",
    accessories: "Accessories",
    about: "About",
    contact: "Contact",

    // Accessories Page
    accHeroTitle: "Premium Accessories",
    accHeroDesc: "Complete your digital experience with our accessories carefully selected for their quality, design and performance.",
    showPrices: "Show prices",
    hidePrices: "Hide prices",
    pricesVisible: "Prices visible",
    pricesHidden: "Prices hidden",
    foundAccessories: "accessories found",
    inCategory: "in",
    reviews: "reviews",
    featuresCount: "features",
    add: "Add",
    discover: "Discover",
    viewMoreAccessories: "View more accessories",

    sortLabel: "Sort by:",
    sortName: "Name",
    sortPriceAsc: "Price low to high",
    sortPriceDesc: "Price high to low",
    sortRating: "Top rated",
    stockLabel: "in stock",

    // Categories
    catAllAccessories: "All accessories",
    catAudio: "Audio",
    catProtection: "Protection",
    catCharging: "Charging",
    catSmartwatch: "Smartwatches",
    catPhotoVideo: "Photo & Video",
    catSmartHome: "Smart Home",

    // Colors
    colorWhite: "White",
    colorBlack: "Black",
    colorBlue: "Blue",
    colorSilicone: "Silicone",
    colorTransparent: "Transparent",
    colorGrey: "Grey",
    colorBlackWhite: "Black/White",
    colorSilver: "Silver",
    colorCharcoal: "Charcoal Grey",
    colorMidnight: "Midnight",

    // Badges
    badgeWaterproof: "Waterproof",
    badgeTopQuality: "Top Quality",
    badgeMagSafe: "MagSafe",
    badgeScratchResist: "Scratch Resistant",
    badgeKeyboard: "Integrated Keyboard",
    badgeFast: "Fast",
    badgeUltraFast: "Ultra Fast",
    badge3in1: "3-in-1",
    badgeHighCap: "High Capacity",
    badgeAutonomy: "Autonomy",
    badgeProGaming: "Pro Gaming",
    badgeWireless: "Wireless",
    badgeRGB: "RGB",
    badgeProPhoto: "Pro Photo",
    badgeStabilization: "Stabilization",
    badgeVoiceAssist: "Voice Assistant",
    badgeSmartLight: "Smart Light",

    // Preview
    prevSlide: "Previous slide",
    nextSlide: "Next slide",
    goToSlide: "Go to slide",

    // Footer
    subscribe: "Subscribe",
    emailPlaceholder: "Your email...",
    newsletterTitle: "Stay Connected",
    newsletterDesc: "Receive our latest offers and news directly in your inbox.",
    newsletterSuccess: "You are now subscribed to our newsletter.",
    congrats: "Congratulations!",
    brandDesc: "Your trusted partner in the digital world in Haiti. We accompany you with expertise and passion towards the technologies of tomorrow.",

    // Footer Links
    ftProducts: "Products",
    ftServices: "Services",
    ftCompany: "Company",

    ftSmartphones: "Smartphones",
    ftAccessories: "Accessories",
    ftGaming: "Gaming",
    ftLaptops: "Laptops & Tablets",
    ftSmartwatches: "Smartwatches",

    ftRepairs: "Repairs",
    ftGuide: "Buying Guide",
    ftSupport: "Technical Support",
    ftRefurb: "Refurbishing",
    ftInstall: "Installation",

    ftStory: "Our Story",
    ftCareers: "Careers",
    ftPress: "Press",
    ftBlog: "Blog",
    ftEvents: "Events",

    ftSupportTitle: "Support",
    ftHelpCenter: "Help Center",
    ftContactUs: "Contact Us",
    ftFAQ: "FAQ",
    ftServiceStatus: "Service Status",

    ftLegalTitle: "Legal",
    ftLegalNotice: "Legal Notice",
    ftPrivacyPolicy: "Privacy Policy",
    ftTermsService: "Terms of Service",

    ftCookies: "Cookies",
    ftFollowUs: "Follow Us",
    ftCopyright: "All rights reserved.",
    ftSecurePayments: "Secure Payments:",
    ftCustomerService: "Customer Service:",
    ftSecurePaymentBadge: "100% Secure Payment",
    ftFastDelivery: "Fast Delivery in Haiti",
    ftReturns: "Returns within 15 days",
    ftServiceScore: "Customer Service 5/5",

    // Address Components
    addrSud: "Department of South",
    addrNord: "Department of North",
    addrOuest: "Department of West",
    addrCentre: "Department of West",
    viewOnMap: "View on Map",

    // Image Gallery
    imgStorefront: "Our main store",
    imgInterior: "Modern exhibition space",
    imgSmartphone: "Our latest smartphones",
    imgService: "Personalized support",
    imgRepair: "Expert technical workshop",
    imgGaming: "Dedicated gaming zone",
    imgAccessories: "Wide choice of accessories",
    imgTeam: "Our team of experts",
    imgPrev: "Previous image",
    imgNext: "Next image",
    goToImage: "Go to image",

    // About Page
    aboutHeroTitle: "Our History",
    aboutHeroDesc: "From technology enthusiasts to digital reference in Haiti, discover our journey, our values and our mission.",
    aboutWhoTitle: "Who are we?",
    aboutWhoDesc: "Michel Cell is a Haitian company specializing in mobile technology, electronics and repair services. We have made it our mission to make technology accessible to everyone in Haiti.",
    aboutPresenceTitle: "Our Presence",
    aboutPresenceDesc: "Present in 4 cities across Haiti with 4 physical stores, we are located as close as possible to our customers. Our network is constantly expanding to better serve each region.",
    aboutMissionTitle: "Our Mission",
    aboutMissionDesc: "Democratize access to quality technology in Haiti by offering suitable products, reliable repair services and expert advice at accessible prices.",
    aboutCommitTitle: "Our Commitment",
    aboutCommitDesc: "At Michel Cell, every customer counts. We believe in a personalized approach where listening, respect and transparency are at the heart of all our interactions. Our team is committed to offering you the best service, whether it is a purchase, a repair or simple advice.",

    aboutValExpertise: "Technical Expertise",
    aboutValExpertiseDesc: "Our technicians are certified and undergo regular training to master the latest technologies.",
    aboutValTrust: "Trust & Transparency",
    aboutValTrustDesc: "We establish a relationship of trust with our customers through clear and transparent communication.",
    aboutValInnovation: "Continuous Innovation",
    aboutValInnovationDesc: "We stay at the forefront of innovation to offer you the most advanced products and services.",
    aboutValPersonalized: "Personalized Service",
    aboutValPersonalizedDesc: "Each customer is unique. We adapt our advice and solutions to your specific needs.",

    aboutStatsExp: "Years of Experience",
    aboutStatsCust: "Satisfied Customers",
    aboutStatsProd: "Products in Stock",
    aboutStatsRepair: "Devices Repaired",

    mile2017: "Opening",
    mile2017Desc: "First store in the south of Haiti",
    mile2019: "Expansion",
    mile2019Desc: "Opening of the second store in the north",
    mile2020: "Repair Service",
    mile2020Desc: "Launch of the expert repair service",
    mile2022: "E-commerce",
    mile2022Desc: "Implementation of our online store",
    mile2023: "Gaming Zone",
    mile2023Desc: "Creation of a space dedicated to gamers",
    mile2024: "Innovation",
    mile2024Desc: "Integration of augmented reality services",

    svcSalesTitle: "Product Sales",
    svcSalesDesc: "Smartphones, tablets, accessories and electronic equipment from the best brands at competitive prices.",
    svcRepairTitle: "Repair Service",
    svcRepairDesc: "Fast and reliable repair of all types of electronic devices by our certified technicians.",
    svcGamingTitle: "Gaming Space",
    svcGamingDesc: "Specialized products and advice for gamers: consoles, accessories, streaming equipment and more.",

    // Brands Section
    brandsTitle: "All Brands, One Expert",
    brandsDesc: "Discover our vast selection of trusted brands, carefully chosen to offer you the best in technology and performance.",

    // Brand Stats
    brandStatsBrands: "Available Brands",
    brandStatsExpert: "Expert",
    brandStatsSupport: "Personalized Support",

    // Our Vision Section
    visionTitle: "Our Vision and Values",
    visionDesc: "Revolutionizing the digital experience through expertise, innovation, and an unwavering commitment to excellence.",
    missionTitle: "Our Mission",
    missionDesc: "At MichelCell, our mission is to provide innovative and personalized digital solutions that meet the unique needs of each client. We strive to create an exceptional user experience by combining technical expertise, attentive customer service, and a commitment to quality.",
    commitmentTitle: "Our Commitment",
    commitmentDesc: "We are committed to providing quality products, expert advice, and exceptional after-sales service. Your satisfaction is our top priority, and we work every day to earn your trust.",

    valInnovation: "Continuous Innovation",
    valInnovationDesc: "We stay at the forefront of technology to bring you the latest innovations and trends in the digital market.",
    valQuality: "Premium Quality",
    valQualityDesc: "Each product is carefully selected and tested to ensure impeccable excellence.",
    valSupport: "Personalized Support",
    valSupportDesc: "Our team of experts guides you in your choices with advice tailored to your specific needs.",
    valSustainable: "Sustainable Development",
    valSustainableDesc: "We are committed to an eco-responsible approach with refurbished and recyclable products.",

    statsClients: "Satisfied Clients",
    statsClientsDesc: "A loyal community that trusts us",
    statsProducts: "Available Products",
    statsProductsDesc: "A constantly updated premium selection",
    statsExpertise: "Years of Expertise",
    statsExpertiseDesc: "Expertise acquired over the years",

    journeyTitle: "Our Journey",
    milestone2015Title: "Foundation",
    milestone2015Desc: "Opening of our first digital space",
    milestone2018Title: "Expansion",
    milestone2018Desc: "Launch of our expert repair service",
    milestone2021Title: "Transformation",
    milestone2021Desc: "Complete digitalization and e-commerce",
    milestone2024Title: "Innovation",
    milestone2024Desc: "Integration of AI and augmented reality",

    ctaVisionTitle: "Ready to Join the Adventure?",
    ctaVisionDesc: "Discover how we can transform your digital experience and guide you towards the technological future.",
    ctaDiscover: "Discover Our Services",
    ctaAppointment: "Make an Appointment",

    // Products Preview
    featuredProductsTitle: "Featured Products",
    featuredProductsDesc: "Explore our exclusive selection of high-tech products at the best prices.",
    addToCart: "Add to cart",
    viewDetails: "View details",
    addToFavorites: "Add to Favorites",
    compare: "Compare",
    viewAllProducts: "View All Products",

    // Products Page
    productsHeroTitle: "Our Collection",
    productsHeroDesc: "Discover our premium selection of high‑tech products, carefully chosen for their exceptional quality and performance.",
    sortLabel: "Sort by:",
    sortName: "Name",
    sortPriceAsc: "Price low to high",
    sortPriceDesc: "Price high to low",
    sortRating: "Top rated",
    catAll: "All products",
    catTablets: "Tablets",
    catSmartphones: "Smartphones",
    catLaptops: "Laptops",
    catGaming: "Gaming",
    stockLabel: "in stock",
    featuresLabel: "features",
    viewButton: "View",
    loadMore: "Load more products",
    statAvailable: "Available products",
    statRating: "Average rating",
    statDelivery: "Express delivery",

    // Additional Badges
    badgePro: "Professional",
    badgeUltimate: "Ultimate",
    badgeVersatile: "Versatile",

    // Product Categories
    catSmartphone: "Smartphone",
    catConsole: "Gaming Console",
    catLaptop: "Laptop",
    catAccessories: "Accessories",

    // Product Badges
    badgeNew: "New",
    badgeAI: "AI Integrated",
    badgePromo: "Promo",
    badgeEco: "Eco-friendly",
    badgeBestseller: "Best-seller",
    badgePure: "Pure Android",

    // Product Features
    featScreen61: '6.1" Super Retina XDR Screen',
    featChipA17: "A17 Pro Chip",
    featCam48: "48MP Camera",
    featTitanium: "Titanium",
    featScreen62: '6.2" Dynamic AMOLED Screen',
    featSnap8: "Snapdragon 8 Gen 3",
    featAI: "AI Integration",
    feat7Updates: "7 years updates",
    feat1TB: "1TB SSD",
    feat4K: "4K 120Hz",
    featRayTracing: "Ray Tracing",
    featDualSense: "DualSense",
    featChipM3: "M3 Chip",
    featScreen15: '15" Liquid Retina',
    feat18h: "18h battery life",
    feat8GB: "8GB RAM",
    featANC: "Active Noise Cancellation",
    featSpatial: "Spatial Audio",
    featMagSafe: "MagSafe",
    feat30h: "30h battery",
    featAndroid14: "Android 14",
    featCam50: "50MP Camera",
    featTensor: "Tensor G3",

    // Testimonials
    testimonialsTitle: "What Our Customers Say",
    testimonialsSubtitle: "Discover the experiences of those who trust us with their technology needs.",
    prevTestimonial: "Previous testimonial",
    nextTestimonial: "Next testimonial",
    goToTestimonial: "Go to testimonial",

    testim1Role: "Satisfied Customer",
    testim1Text: "With MichelCell, I found a phone that suits my taste! Customer service was excellent and I recommend them to everyone.",

    testim2Role: "Passionate Gamer",
    testim2Text: "I had been looking for a gaming laptop for a long time, MichelCell helped me find one perfect for my needs. The buying experience was easy and fast.",

    testim3Role: "Professional",
    testim3Text: "My MacBook is like new after the repair. Speed and expertise were there. A quality service that I will recommend.",

    testim4Role: "Law Student",
    testim4Text: "Regarding phone and accessories purchases, MichelCell gave me an unparalleled experience. Thanks for all the help!",

    testim5Role: "Amateur Photographer",
    testim5Text: "I love my new camera! MichelCell helped me choose it and the service was extraordinary. I will always buy here.",

    // Stats
    statClients: "Satisfied Customers",
    statProducts: "Products Sold",
    statReviews: "Positive Reviews",
    statSatisfaction: "Satisfaction Rate",
    statSupport: "Responsive Support",

    // Contact Page
    contactHeroTitle: "Contact Us",
    contactHeroDesc: "Our team is here to answer all your questions. Do not hesitate to contact us for advice, repairs, or any other request.",
    contactQuickTitle: "Quick Contact",
    contactEmergencyTitle: "🔴 Technical Emergency?",
    contactEmergencyDesc: "For urgent repairs or critical technical problems",
    contactEmergencyBtn: "Emergency: +509 4776 3992",
    contactRepairBtn: "Repair Service",

    contactFormTitle: "Send us a message",
    contactSuccessTitle: "✅ Message sent!",
    contactSuccessDesc: "Thank you for your message. Our team will answer you as soon as possible.",
    contactLabelName: "Full Name *",
    contactPlaceName: "Your name",
    contactLabelEmail: "Email *",
    contactPlaceEmail: "your@email.com",
    contactLabelPhone: "Phone",
    contactPlacePhone: "+509 XX XX XX XX",
    contactLabelSubject: "Subject *",
    contactSelectSubject: "Select a subject",
    contactLabelMessage: "Message *",
    contactPlaceMessage: "Describe your request in detail...",
    contactBtnSend: "Send Message",
    contactBtnSending: "Sending...",
    contactDisclaimer: "* Required fields. We usually answer within 24h.",
    contactNewsletter: "I wish to receive special offers and news",

    contactSubjInfo: "Information Request",
    contactSubjSupport: "Technical Support",
    contactSubjRepair: "Device Repair",
    contactSubjOrder: "Special Order",
    contactSubjReturn: "Product Return",
    contactSubjPartner: "Business Partner",
    contactSubjOther: "Other",

    contactFaqTitle: "Frequently Asked Questions",
    contactFaq1Q: "What are your opening hours?",
    contactFaq1A: "Our stores are open Monday to Saturday from 8am to 7pm, and Sunday from 10am to 5pm.",
    contactFaq2Q: "How long does a repair take?",
    contactFaq2A: "Most repairs are done in 24-48h. For complex cases, we will keep you informed of the estimated delay.",
    contactFaq3Q: "Do you offer warranty on your products?",
    contactFaq3A: "Yes, all our products have a minimum one-year warranty. Refurbished products have a 6-month warranty.",
    contactFaq4Q: "Do you accept online orders?",
    contactFaq4A: "Yes, you can order online and pick up in store, or benefit from our delivery service.",
    contactFaqLink: "View all FAQs",
    contactWhatsAppLabel: "WhatsApp: +(509) 4776 3992",
    contactFacebookLabel: "Facebook: @michelcell_ht",
    contactInstagramLabel: "Instagram: @michelcell_ht",
  }
};
